import React, { useState } from 'react';
import {
  Box,
  Typography,
  SvgIcon,
  IconButton,
} from '@mui/material';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import Tooltip from 'src/components/Tooltip';
import ModalDialogVideo from 'src/components/ModalDialogVideo/index';

function DefaultMessagesView() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            marginBottom: '17px',
            padding: '27px',
            backgroundColor: '#FFFFFF',
            borderRadius: '50%',
          }}
        >
          <Tooltip
            title="How to use Connections"
            placement="top"
          >
            <IconButton
              color="secondary"
              onClick={handleOpen}
              size="large"
              sx={{
                padding: 0,
              }}
            >
              <SvgIcon
                component={OndemandVideoIcon}
                sx={{
                  fontSize: 64,
                  color: '#B2AFF6',
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>
        <Typography
          variant="h6"
          color="textSecondary"
        >
          How to use Connections
        </Typography>
      </Box>
      <ModalDialogVideo
        onClose={handleClose}
        isVisible={open}
        videosrc="https://player.vimeo.com/video/1069660533"
        title="How to use Connections"
        largeModal
      />
    </>
  );
}

export default DefaultMessagesView;
